export default __webpack_public_path__ + "static/media/refinance.9eacf8f0.svg";